import { updateLiquidityRecurringCashflowItemSettings } from '../../../app/api/generated/client';
import { queryKeys } from '../query-keys';
import { useLiquiditySettingsMutation } from './use-liquidity-settings-mutation';

export const useUpdateLiquidityRecurringCashflowItemSettings = () =>
    useLiquiditySettingsMutation({
        mutationFn: (payload) => updateLiquidityRecurringCashflowItemSettings({ body: payload, path: { id: payload.id! } }).then((result) => result.data!),
        settingsQueryKey: queryKeys.liquidityRecurringCashflowSettings,
        scope: 'item',
    });
